import React from "react";
import GraphHeader from "./GraphHeader";
import GridData from "./GridData";
import ChartBar from "./ChartBar";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "src/store";
import {
  setViewInStore,
} from "src/slices/bkvReducer";
import { useEffect, useState } from "react";
import { Container } from "@material-ui/core";
import { ComparisonChart } from "../ComparisonChart";
import UsageModal from "./UsageModal";
const CustomH1 = styled("h1")({
  color: "#09507F",
  fontFamily: "Larken",
  fontSize: "36px",
  fontWeight: 400,
  lineHeight: "47.7px",
  textAlign: "left",
  marginLeft: "40px",
  marginTop: "28px",
  marginBottom: "28px",
});

const CustomDiv = styled("div")({
  // marginTop: "35px", // Added margin to the top
  // marginBottom: "40px", // Added margin to the bottom
  // marginLeft: "20px", // Added margin to the left
  // marginRight: "20px", // Added margin to the right
  padding: "20px 0",
});

const state = {
  usage: {
    Jan: 1000,
    Feb: 1100,
    Mar: 1200,
    Apr: 1300,
    May: 1400,
    Jun: 1500,
    Jul: 1600,
    Aug: 1700,
    Sep: 1800,
    Oct: 1900,
    Nov: 2000,
    Dec: 2100,
  },
  gimmicky: {
    kWh2500: "12.5",
    kWh2000: "11.0",
    kWh1500: "10.0",
    kWh1000: "9.0",
    kWh500: "8.0",
  },
  bluebonnet: {
    rate: "10¢",
  },
};

const initModal = {
  usageModal: false,
};

export type modalTypes = "usageModal" | "usageGraph" | "all";

const Graph = () => {
  const [graphData, setGraphData] = useState([]);
  const [csavingsPercentage, setCsavingsPercentage] = useState(0);
  const [modal, setModal] = useState(initModal);
  const [csavings, setCsavings] = useState(0);
  const state = useSelector((state) => state.bkv);
  const dispatch = useDispatch();

  const handleOpen = (key: modalTypes) => {
    setModal({
      ...modal,
      [key]: true,
    });
  };

  const monthTicks = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    const costData = [];
    const usageArr = Object.values(state.usage) as number[];
    for (let index = 0; index < 12; index++) {
      const usage = usageArr[index];
      let temp = 2500;
      [2000, 1500, 1000, 500].forEach((item) => {
        if (usage < temp) {
          temp = item;
        }
      });
      const gimKey = `kWh${temp}`;
      const gim =
        parseInt(
          Number(state.gimmicky?.[gimKey]?.replace("¢", "") ?? "0").toFixed(0)
        ) / 100;
      const bb =
        parseInt(Number(state.bluebonnet?.rate.replace("¢", "")).toFixed(0)) /
        100;
      costData.push({
        name: monthTicks[index],
        gimmicky: parseInt((gim * usage).toFixed(0)),
        bluebonnet: parseInt((bb * usage).toFixed(0)),
      });
    }

    const gimmickysum = costData.reduce((accumulator, object) => {
      return accumulator + object.gimmicky;
    }, 0);

    const bluebonnetsum = costData.reduce((accumulator, object) => {
      return accumulator + object.bluebonnet;
    }, 0);

    const cumulativeSavingsPercentage =
      ((gimmickysum - bluebonnetsum) / gimmickysum) * 100;
    setCsavingsPercentage(cumulativeSavingsPercentage);
    setCsavings(gimmickysum - bluebonnetsum);
    setGraphData(costData);
    console.log("costData", costData);
  }, [state.bluebonnet?.rate, state.gimmicky, state.usage]);

  const [plan1, setPlan1] = useState<any>(null);
  const [plan2, setPlan2] = useState<any>(null);
  const [usage, setUsage] = useState<number>(0);

  const handleClose = (key: modalTypes) => {
    if (key === "all") {
      setModal(initModal);
    } else {
      setModal({
        ...modal,
        [key]: false,
      });
      if (key === "usageModal") {
        dispatch(setViewInStore("options"));
      }
    }
  };

  return (
    <>
      <Container>
        <CustomDiv>
          <GraphHeader setPlan1={setPlan1} setPlan2={setPlan2} />
        </CustomDiv>

        <CustomDiv>
          <GridData plan1={plan1} plan2={plan2} />
        </CustomDiv>

       {plan1 && plan2 && <ChartBar plan1={plan1} plan2={plan2} />}
        {/* <SavingsGraph data={graphData} dataKey="name" /> */}
        {plan1 && plan2 && <ComparisonChart
          handleOpen={(key) => handleOpen(key)}
          plan1={plan1}
          plan2={plan2}
        />}
      </Container>
      <UsageModal
        open={modal.usageModal}
        handleClose={(key) => handleClose(key)}
        view={"options"}
      />
    </>
  );
};

export default Graph;
